<!-- 捐赠寄语页面
捐赠指数页面点击捐赠寄语跳转至该页面 -->
<template>
  <div class="messageDiv">
    <van-list :immediate-check="false" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="message" v-for="item in message" :key="item.id">
        <!-- <div class="messageLeft">
          <div class="photoDiv">
            <image :src="item.url" round alt="照片" class="photo" />
          </div>
          <div class="sexDiv">
            <img src="../../assets/image/btn_nan_nor.png" alt="" v-if="item.sex == 1" class="sex" />
            <img src="../../assets/image/btn_nv_nor.png" alt="" v-else class="sex" />
          </div>
          <div class="adress">{{ item.city }}</div>
        </div> -->
        <div class="messageRight">
          <div class="name">{{ item.name }}</div>
          <div class="messageWord">{{ item.message }}</div>
          <div class="messageInfo">
            <div class="date">日期：{{ item.created_at}}</div>
            <div class="moneyNum">金额：{{ item.total_money}}元</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: [],
      postData: {
        page: 1,
        pageSize: 10,
      },
      lastPage: '',
      loading: false,
      finished: false,
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    async getMessage() {
      const result = await this.$http.get('/donates/getDonateRecord', {
        params: { currentPage: this.postData.page, perPage: this.postData.pageSize },
      });
      console.log('result--result', result.data.list)
      this.message = result.data.list;
      // for (let i = 0; i < result.data.list.length; i++) {
      //   this.message.push(result.data.list[i]);
      // }
      this.lastPage = result.data.lastPage;
    },
    // 懒加载
    onLoad() {
      this.postData.page = this.postData.page + 1;
      this.getMessage();
      this.loading = false;
      // 数据全部加载完成
      if (this.postData.page >= this.lastPage) {
        this.finished = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.messageDiv {
  position: relative;
  padding: 0.84rem 1.14rem;
}
.message {
  display: flex;
  position: relative;
  background-color: white;
  border-radius: 15px;
  border: 0.04px solid #e1e1e1;
  padding: 1.03rem 0.69rem;

  & + & {
    margin-top: 0.84rem;
  }
}
.messageLeft {
  flex: 0 0 auto;
  position: relative;
}
.messageRight {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 0.95rem;
}
.photoDiv {
  width: 4.5rem;
  height: 4.5rem;
  // padding: 10px 0px 0px 10px;
}
.photo {
  width: 100%;
  height: 100%;
}
.sexDiv {
  position: absolute;
  top: 0.7rem;
  right: 0.7rem;
  transform: translate(50%, -50%);
  width: 22px;
}
.sex {
  width: 100%;
}
.adress {
  text-align: center;
  font-size: 1rem;
  color: #00706E;
  line-height: 1.52rem;
  margin-top: 0.72rem;
  font-weight: 600;
}
.name {
  font-size: 1rem;
  font-weight: bold;
  color: #333333;
}
.messageWord {
  flex: 1 1 auto;
  margin-top: 0.76rem;
  font-size: 0.9rem;
  color: #666666;
  line-height: 1.52rem;
}
.date {
  float: left;
  color: #999999;
  width: 60%;
  font-size: 0.9rem;
}
.moneyNum {
  float: right;
  padding-right: 10px;
  color: #999999;
  font-size: 0.9rem;
}

.messageInfo {
  display: flex;
  justify-content: space-between;
}

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/DonationMessage.vue